import React, { useState, useEffect } from "react";

const EventCallout = () => {
  function insertLastWednesday() {
    // Get the current date
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth();

    // Find the last day of the current month
    const lastDay = new Date(currentYear, currentMonth + 1, 0);

    // Work backwards from the last day to find the last Wednesday
    let lastWednesday = new Date(lastDay);
    while (lastWednesday.getDay() !== 3) {
      // 3 represents Wednesday (0=Sunday, 1=Monday, etc.)
      lastWednesday.setDate(lastWednesday.getDate() - 1);
    }

    // Format the date as a readable string
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric"
    };
    const formattedDate = lastWednesday.toLocaleDateString("en-US", options);

    return formattedDate;
  }

  return (
    <div className="site-banner">
      <div className="site-banner-inner">
        <h6 className="site-inner-content"> 
          Our next meetup is {insertLastWednesday()}.
          <a href="https://www.instagram.com/eavboardgames/" target="_blank">
            Event Details
          </a>
         <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 16L16 12M16 12L12 8M16 12H8M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
         </svg>
        </h6>
      </div>
      <blockquote className="instagram-media" 
      data-instgrm-permalink="https://www.instagram.com/eavboardgames/?utm_source=ig_embed&amp;utm_campaign=loading" 
      data-instgrm-version="14" target="_blank"></blockquote>
      <script async src="//www.instagram.com/embed.js"></script>
    </div>
  );
};

export default EventCallout;
